export default {
  SET_INGREDIENTS(state, payload) {
    state.ingredients = payload;
  },
  // SET_OBJECT_COMPANIES(state, payload) {
  //   state.objectCompanies = payload;
  // },
  CLEAR_OBJECT_COMPANIES(state) {
    state.objectCompanies = {data: []};
  },
  SET_OBJECT_COMPANIES(state, payload) {
    state.objectCompanies = {
      ...payload,
      data: Array.from(new Set([...state.objectCompanies.data, ...payload.data].map(JSON.stringify))).map(JSON.parse)
    };
  },
};
